module.exports = __webpack_public_path__ + "media/images/city_img/icon5-6ca42bca81b66331c80bfb4aa9e0039a.png";